import styled from 'styled-components';
import breakpoint from '../../../utils/style-utils';

/**
 * The metter of this file to hold fallbacks for features which we are lazy loading in ./sportsbook-async.js
 *
 */

const ContentBG = styled.div<{ width?: string; height?: string; flexGrow?: number }>`
	/* flex: 1; */
	border-radius: var(--sportsbook-rounded-lg);
	background: var(--sportsbook-bg-primary);

	/* ${({ width, height, flexGrow }) =>
		`width: ${width || 'auto'}; height: ${height || 'auto'}; flex-grow: ${flexGrow || 0};`} */
`;

const PromotionCarouselContent = styled(ContentBG)`
	width: 100%;
	height: 190px;
	border-radius: 0; // no need of this for mobile

	${breakpoint.lg`
		border-radius: var(--sportsbook-rounded-lg);
	`}
`;

const RecommendedBetsCarouselContent = styled(ContentBG)`
	width: 100%;
	height: 92px;
	border-radius: 0; // no need of this for mobile

	${breakpoint.lg`
		border-radius: var(--sportsbook-rounded-lg);
	`}
`;

export const PromotionCarouselFallback = () => <PromotionCarouselContent />;
export const RecommendedBetsCarouselFallback = () => <RecommendedBetsCarouselContent />;
